module.exports = __webpack_public_path__ + "img/chijieban4.c125d3dc.jpg";